var _a;
import * as tslib_1 from "tslib";
import { ApiTypes } from '../../types';
import { QueryBuilder } from '../QueryBuilder/QueryBuilder';
export var GroupsRequestSort;
(function (GroupsRequestSort) {
    GroupsRequestSort["MEMBERS_COUNT"] = "members_count";
    GroupsRequestSort["RECENT_ACTIVITY"] = "recent_activity_date";
    GroupsRequestSort["NAME"] = "title";
})(GroupsRequestSort || (GroupsRequestSort = {}));
export var GroupSortFieldMapping = (_a = {},
    _a[ApiTypes.v1.GroupsSortBy.RECENT_ACTIVITY] = GroupsRequestSort.RECENT_ACTIVITY,
    _a[ApiTypes.v1.GroupsSortBy.MEMBERS_COUNT] = GroupsRequestSort.MEMBERS_COUNT,
    _a[ApiTypes.v1.GroupsSortBy.NAME] = GroupsRequestSort.NAME,
    _a[GroupsRequestSort.RECENT_ACTIVITY] = ApiTypes.v1.GroupsSortBy.RECENT_ACTIVITY,
    _a[GroupsRequestSort.MEMBERS_COUNT] = ApiTypes.v1.GroupsSortBy.MEMBERS_COUNT,
    _a[GroupsRequestSort.NAME] = ApiTypes.v1.GroupsSortBy.NAME,
    _a);
var GroupsRequestBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(GroupsRequestBuilder, _super);
    function GroupsRequestBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupsRequestBuilder.prototype.sortByMembersCount = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.MEMBERS_COUNT, order);
    };
    GroupsRequestBuilder.prototype.sortByRecentActivity = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.RECENT_ACTIVITY, order);
    };
    GroupsRequestBuilder.prototype.sortByName = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.NAME, order);
    };
    GroupsRequestBuilder.prototype.build = function () {
        return { query: this.query };
    };
    return GroupsRequestBuilder;
}(QueryBuilder));
export { GroupsRequestBuilder };
//# sourceMappingURL=GroupsRequestBuilder.js.map